export default function getUserRole(appState) {
    if (!appState.role) {
        return null;
    }
    if (!appState.roles || appState.roles.length === 0) {
        return null;
    }

    const role = appState.roles.find(r => r.name === appState.role);

    if (!role) {
        console.warn(`No role in appState Roles whith the name '${appState.role}'`);
        return null;
    }

    return role;
}

export function getRoleByName(appState, roleName) {
    if (!roleName) {
        console.warn("No role name provided");
        return null;
    }
    if (!appState.roles || appState.roles.length === 0) {
        console.warn("No roles in appState");
        return null;
    }

    const role = appState.roles.find(r => r.name === roleName);

    if (!role) {
        console.warn(`No role in appState Roles whith the name '${roleName}'`);
        return null;
    }

    return role;
}

export function getRoleById(appState, roleId) {
    if (!roleId) {
        console.warn("No role id provided");
        return null;
    }
    if (!appState.roles || appState.roles.length === 0) {
        console.warn("No roles in appState");
        return null;
    }

    const role = appState.roles.find(r => r.id === roleId);

    if (!role) {
        console.warn(`No role in appState Roles whith the id '${roleId}'`);
        return null;
    }

    return role;
}